module.exports = __webpack_public_path__ + "static/media/whocansee.0a58db4a.png";